define('LNRS/Track/TrackForms',[
    "jquery",
    "eventManager",
    "Track/DataLayerManager",
    "Track/Events"
], function ($, eventManager, dlmanager, events) {

    return function trackForms() {

        // 7.4.1 Contact LNRS
        eventManager.subscribe(events.global.formSubmitted, function (formName, formValues, submissionId, hasAsset) {
            var o = { site_events: { "contact_us": "true" }, event_name: "contact us" };
            o["form_name"] = formName;
            o["handraiser"] = formValues;

            if (submissionId) {
                o["eloqua_submission_id"] = submissionId;
            }

            if (hasAsset) {
                o.site_events["gated_asset"] = "true";
            }

            dlmanager.trackAnalytics(o);
        });

        // Track VWO Events
        eventManager.subscribe("VWOEvent", function (vwoEventValues, eventName) {            
            dlmanager.trackVWOEvents(vwoEventValues, eventName);
        });

        eventManager.subscribe(events.global.vwoEloquaFormSuccess, function ($formInstance, isSuccess) {
            dlmanager.trackVWOEloquaFormSubmission($formInstance, isSuccess);
        });

        // 7.8.1 Form Errors
        eventManager.subscribe(events.global.formErrors, function (formName, formErrors) {
            var o = { site_events: { "form_error": "true" }, event_name: "form error" };
            o["form_name"] = formName;
            o["error_code"] = formErrors;
            dlmanager.trackAnalytics(o);
        });
    }
});
